import { TenantType } from '@payflip/utils';
import React from 'react';
import { AcertaLogo } from './logo-acerta';
import { CipalLogo } from './logo-cipal';
import { LiantisLogo } from './logo-liantis';
import { PayflipLogo } from './logo-payflip';

export const logos: Partial<
  Record<TenantType, React.FunctionComponent<{ noText?: boolean }>>
> = {
  CIPAL: CipalLogo,
  PAYFLIP2: PayflipLogo,
  ACERTA: AcertaLogo,
  LIANTIS: LiantisLogo
} as const;
